import { createQueryHook } from "../factory";

const claimKeys = {
  all: ["claims"] as const,
  lists: () => [...claimKeys.all, "list"] as const,
  list: <T>(filters: T) => [...claimKeys.lists(), filters] as const,
  details: () => [...claimKeys.all, "detail"] as const,
  detail: ({ id }: { id: string }) => [...claimKeys.details(), id] as const,
  batchClaims: <T>(filters: T) =>
    [...claimKeys.all, "batchClaims", filters] as const,
};

export const claims = {
  getProviderClaim: createQueryHook({
    methodSelector: (alaffiaClient) => alaffiaClient.claims.getProviderClaim,
    queryKeyFn: claimKeys.detail,
  }),
  getAllClaims: createQueryHook({
    methodSelector: (alaffiaClient) => alaffiaClient.claims.getAllClaims,
    queryKeyFn: claimKeys.list,
  }),
  batchClaims: createQueryHook({
    methodSelector: (alaffiaClient) => alaffiaClient.claims.batchClaims,
    queryKeyFn: claimKeys.batchClaims,
  }),
};
